import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    display: 'flex',
  },
  iconColumn: {
    fontSize: pxToRem(18),
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    paddingTop: pxToRem(3),
  },
  statusText: {
    fontSize: pxToRem(12),
    fontWeight: 400,
  },
});
